import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { socket } from "../../App";
import { ReactComponent as EmojiBtnIcon } from "../../assets/icons/EmojiBtnIcon.svg";
import { ReactComponent as SendIcon } from "../../assets/icons/SendIcon.svg";
import LoveIcon from "../../assets/svg/LoveIcon.svg";
import backArrow from "../../assets/svg/backArrow.svg";
import downArrow from "../../assets/svg/downArrow.svg";
import axios from "../../components/Hooks/axios";
import styles from "./CommentContainer.module.scss";
import EmojiPicker from "emoji-picker-react";
import Avatar from "../../components/Avatar/Avatar";
import { IoCloseOutline } from "react-icons/io5";

const CommentContainer = ({ setShow, commentsData, setCommentsData, postId, data }) => {
	const { userId, user } = useSelector((state) => state.auth);

	const [commentText, setCommentText] = useState("");
	const [commentId, setCommentId] = useState("");
	const [replyMainId, setReplyMainId] = useState("");
	const [replyId, setReplyId] = useState("");
	const inputRef = useRef();
	const [openEmoji, setOpenEmoji] = useState(false);

	const fetchComments = () => {
		axios
			.get(`/post/${postId}/getcomments`)
			.then(({ data }) => {
				setCommentsData(data.comments);
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		fetchComments();
	}, []);

	const postComment = () => {
		let sd = {
			notification_from: userId,
			notification_to: data.userId._id,
			notification: {},
			title: "Comment",
			message: `${user.username} comment on your post`,
		};

		if (commentText === "") return toast.warn("Please write something !");
		const id = toast.loading("Comment Posting...");
		axios
			.post(`/post/${postId}/comment`, {
				userId,
				text: commentText,
			})
			.then(({ data }) => {
				toast.update(id, {
					render: data.message,
					type: "success",
					isLoading: false,
					autoClose: 2000,
				});
				setCommentsData(data.post.Comments);
				setCommentText("");
				socket.emit("notification", sd);
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const postCommentOnComment = () => {
		let sd = {
			notification_from: userId,
			notification_to: data.userId._id,
			notification: {
				link: `/Post/${postId}`
			},
			title: "Comment",
			message: `${user.username} replied to a comment on your post`,
		};

		if (commentText === "") return toast.warn("Please write something !");
		const id = toast.loading("Comment Posting...");
		axios
			.post(`/post/comment-on-comment?postId=${postId}&commentId=${commentId}&userId=${userId}`, {
				text: commentText,
			})
			.then(({ data }) => {
				toast.update(id, {
					render: data.message,
					type: "success",
					isLoading: false,
					autoClose: 2000,
				});
				setCommentText("");
				fetchComments();
				setCommentId("");
				inputRef?.current?.blur();
				socket.emit("notification", sd);
			})
			.catch(({ response: { data } }) => {
				toast.update(id, {
					render: data.message,
					type: "error",
					isLoading: false,
					autoClose: 2000,
				});
			});
	};

	const postReplyOnReply = () => {
		let sd = {
			notification_from: userId,
			notification_to: data.userId._id,
			notification: {
				link: `/Post/${postId}`
			},
			title: "Comment",
			message: `${user.username} replied to a comment on your post`,
		};

		if (commentText === "") return toast.warn("Please write something !");
		const id = toast.loading("Comment Posting...");
		axios
			.post(
				`/post/comment-on-comment?postId=${postId}&commentId=${replyMainId}&userId=${userId}&replyCommentId=${replyId}`,
				{
					text: commentText,
				}
			)
			.then(({ data }) => {
				toast.update(id, {
					render: data.message,
					type: "success",
					isLoading: false,
					autoClose: 2000,
				});
				setCommentText("");
				fetchComments();
				setReplyMainId("");
				setReplyId("");
				inputRef?.current?.blur();
				socket.emit("notification", sd);
			})
			.catch(({ response: { data } }) => {
				toast.update(id, {
					render: data.message,
					type: "error",
					isLoading: false,
					autoClose: 2000,
				});
			});
	};

	const commentLike = (commentId) => {
		const raw = {
			postId,
			commentId,
			userId,
		};
		axios
			.post(`/post/like-comment`, raw)
			.then(({ data }) => {
				toast.success(data.message);
				setCommentsData(data.comments);
			})
			.catch((err) => {
				toast.error(err.response?.data?.message || "Action failed");
			});
	};

	const getReplyingToUsername = () => {
		const cid = replyId || commentId;
		if (!cid || !commentsData) return null;
		const findInArray = (arr) => {
			for (const c of arr) {
				if (c._id === cid) return c.userId?.username;
				if (c.Comments) {
					const found = findInArray(c.Comments);
					if (found) return found;
				}
			}
			return null;
		};
		return findInArray(commentsData);
	};

	const ReplySubCommentBox = ({ data, parentUsername }) => {
		const date = moment(data?.timestamp).format("hh:mmA [on] DD-MM-YY");
		const isLiked = data.likes?.some(id => (id._id || id).toString() === userId?.toString());
		return (
			<div className={styles.ReplySubCommentBox}>
				<div className={styles.left}>
					<div className={styles.leftImage}>
						<Avatar src={data?.userId?.ProfilePic} name={data?.userId?.username} />
					</div>

					<div className={styles.leftText}>
						<p>{data?.userId?.username}</p>

						<h4>
							{parentUsername && <span className={styles.MentionTag}>@{parentUsername}</span>}
							{data?.text}
						</h4>

						<div>
							<span>{date}</span>
							<span onClick={() => commentLike(data._id)}>{isLiked ? "Unlike" : "Like"}</span>
						</div>
					</div>
				</div>

				<div className={styles.right}>
					<div className={styles.right}>
						{data.likes?.length > 0 && (
							<>
								<p>{data.likes.length}+</p>
								<img src={LoveIcon} alt="" />
							</>
						)}
					</div>
				</div>
			</div>
		);
	};

	const SubCommentBox = ({ data, mainCommentId, parentUsername }) => {
		const date = moment(data?.timestamp).format("hh:mmA [on] DD-MM-YY");
		const isLiked = data.likes?.some(id => (id._id || id).toString() === userId?.toString());
		const isActive = data._id === replyId;
		return (
			<div className={`${styles.SubCommentBox} ${isActive ? styles.ActiveComment : ""}`}>
				<div className={styles.left}>
					<div className={styles.leftImage}>
						<Avatar src={data?.userId?.ProfilePic} name={data?.userId?.username} />
					</div>

					<div className={styles.leftText}>
						<p>{data?.userId?.username}</p>

						<h4>
							{parentUsername && <span className={styles.MentionTag}>@{parentUsername}</span>}
							{data?.text}
						</h4>

						<div>
							<span>{date}</span>
							<span
								style={{
									background: isActive ? "#A6539D" : "",
									color: isActive ? "#fff" : "",
								}}
								onClick={() => {
									if (isActive) {
										setReplyMainId("");
										setReplyId("");
										setCommentId("");
									} else {
										setReplyMainId(mainCommentId);
										setReplyId(data._id);
										setCommentId("");
									}
								}}>
								Reply
							</span>

							<span onClick={() => commentLike(data._id)}>{isLiked ? "Unlike" : "Like"}</span>
						</div>
					</div>
				</div>

				<div className={styles.right}>
					{data.likes?.length > 0 && (
						<>
							<p>{data.likes.length}+</p>
							<img src={LoveIcon} alt="" />
						</>
					)}
				</div>
			</div>
		);
	};

	const CommentBox = ({ data }) => {
		const isLiked = data.likes?.some(id => (id._id || id).toString() === userId?.toString());
		const isActive = data._id === commentId;
		return (
			<div className={`${styles.CommentBox} ${isActive ? styles.ActiveComment : ""}`}>
				<div className={styles.left}>
					<div className={styles.leftImage}>
						<Avatar src={data?.userId?.ProfilePic} name={data?.userId?.username} />
					</div>
					<div className={styles.leftText}>
						<p>{data?.userId?.username}</p>
						<h4>{data?.text}</h4>
						<div>
							<span>{data.likes?.length || 0}+ Likes</span>
							<span
								style={{
									background: isActive ? "#A6539D" : "",
									color: isActive ? "#fff" : "",
								}}
								onClick={() => {
									if (isActive) {
										setCommentId("");
										setReplyMainId("");
										setReplyId("");
									} else {
										setCommentId(data._id);
										setReplyMainId("");
										setReplyId("");
									}
								}}>
								Reply
							</span>
							<span onClick={() => commentLike(data._id)}>{isLiked ? "Unlike" : "Like"}</span>
						</div>
					</div>
				</div>

				<div className={styles.right}>
					{data.likes?.length > 0 && (
						<>
							<p>{data.likes.length}+</p>
							<img src={LoveIcon} alt="" />
						</>
					)}
				</div>
			</div>
		);
	};

	const CommentThreadItem = ({ main }) => {
		const [showReplies, setShowReplies] = useState(true);
		const hasReplies = main?.Comments && main.Comments.length > 0;

		return (
			<div className={styles.ThreadContainer}>
				<CommentBox data={main} />

				{hasReplies && (
					<button
						type="button"
						className={styles.ViewRepliesBtn}
						onClick={() => setShowReplies(!showReplies)}
					>
						<span className={styles.RepliesLine} />
						<span>
							{showReplies
								? `▴ Hide replies (${main.Comments.length})`
								: `↳ View ${main.Comments.length} ${main.Comments.length === 1 ? "reply" : "replies"}`}
						</span>
					</button>
				)}

				{hasReplies && showReplies && (
					<div className={styles.RepliesWrapper}>
						<div className={styles.ThreadLine} onClick={() => setShowReplies(false)} title="Collapse thread" />
						{main.Comments.map((sub, si) => (
							<div key={sub._id || si} className={styles.ReplyItem}>
								<SubCommentBox
									data={sub}
									mainCommentId={main._id}
									parentUsername={main.userId?.username}
								/>

								{sub?.Comments && sub.Comments.length > 0 && (
									<div className={styles.NestedRepliesWrapper}>
										<div className={styles.ThreadLine} />
										{sub.Comments.map((rep, ri) => (
											<div key={rep._id || ri} className={styles.ReplyItem}>
												<ReplySubCommentBox
													data={rep}
													parentUsername={sub.userId?.username}
												/>
											</div>
										))}
									</div>
								)}
							</div>
						))}
					</div>
				)}
			</div>
		);
	};

	useEffect(() => {
		if (commentId !== "") inputRef?.current?.focus();
		if (commentId === "") inputRef?.current?.blur();
	}, [commentId]);

	useEffect(() => {
		if (replyId !== "") inputRef?.current?.focus();
		if (replyId === "") inputRef?.current?.blur();
	}, [replyId]);

	return (
		<div className={styles.CommentMainContainer}>
			{/* <div className={styles.shadowContainer} /> */}
			<div className={styles.CommentInnerContainer}>
				<div className={styles.backBtnContainer}>
					<div className={styles.backArrow}>
						<img src={backArrow} alt="backArrow" onClick={() => setShow(false)} />
						<h3>Comments</h3>
					</div>
					<div className={styles.downArrow}>
						<h3>Latest</h3>
						<img src={downArrow} alt="downArrow" />
					</div>
				</div>

				<div className={styles.CommentBoxContainer}>
					{commentsData.map((main, mi) => (
						<CommentThreadItem key={main._id || mi} main={main} />
					))}
				</div>

				<div className={styles.InputWrapper}>
					{(commentId || replyId) && (
						<div className={styles.ReplyingBanner}>
							<p>Replying to <span>@{getReplyingToUsername()}</span></p>
							<button type="button" onClick={() => { setCommentId(""); setReplyId(""); setReplyMainId(""); }}>
								<IoCloseOutline />
							</button>
						</div>
					)}
					<div className={styles.InputContainer}>
						<div className={styles.InputContainerInner}>
							<input
								type="text"
								value={commentText}
								ref={inputRef}
								placeholder={commentId || replyId ? "Type your reply..." : "Type your Comment"}
								onChange={(e) => setCommentText(e.target.value)}
								onKeyDown={(e) => {
									if (e.key === "Enter") {
										if (commentId === "" && replyId === "") postComment();
										if (commentId !== "") postCommentOnComment();
										if (replyId !== "") postReplyOnReply();
										setOpenEmoji(false);
									}
								}}
							/>
							<button className={styles.EmojiBtn} onClick={() => setOpenEmoji(!openEmoji)}>
								<EmojiBtnIcon />
							</button>
						</div>

						<button
							className={styles.SubmitBtn}
							onClick={() => {
								if (commentId === "" && replyId === "") postComment();
								if (commentId !== "") postCommentOnComment();
								if (replyId !== "") postReplyOnReply();
								setOpenEmoji(false);
							}}>
							<SendIcon />
						</button>

						{openEmoji && (
							<div className={styles.EmojiContainer}>
								<EmojiPicker
									height="100%"
									width="100%"
									onEmojiClick={(e) => setCommentText((prevText) => prevText + e.emoji)}
									emojiStyle={"apple"}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default CommentContainer;


